


















































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import AccountHeader from '@/app/components/Account/AccountHeader.vue'
import Toast from '@/app/components/Common/Toast.vue'
/* api */
import AccountCreateApi from '@/app/model/api/accountCreateApi'
/* module */
import Session from '@/app/module/session'
import Validator from '@/app/module/validator'
import CommonClass from '@/app/module/common'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    AccountHeader,
    Toast
  }
})
export default class AccountCreate extends Vue {
  private account: string = ''
  private name: string = ''
  private tel: string = ''
  private email: string = ''
  private password: string = ''
  private remarks: string = ''
  private errorMessages: any = ''
  private showErrorAlert: boolean = false
  private alertText: string = ''

  /* パスワード自動生成 */
  private displayPassword () {
    this.password = this.createPassword()
  }

  private createPassword () {
    let str: string = 'abcdefghijklmnopqrstuvwxyz0123456789!"#$%&()_-'
    let len: number = 12

    let result: string = ''
    for (var i = 0; i < len; i++) {
      result += str.charAt(Math.floor(Math.random() * str.length))
    }
    return result
  }

  created () {
    this.$store.commit('routeState/setRoute', this.$route.path)
  }

  private async accountCreate () {
    /* バリデーションチェック */
    if (!this.isAccountCreate()) {
      return
    }

    const bodyData = {
      'name': this.name,
      'type': parseInt(this.account),
      'tell': this.tel,
      'mailaddress': this.email,
      'password': this.password,
      'remarks': this.remarks,
      'field_ids': []
    }

    /* アカウント登録処理が成功したらアカウント一覧に遷移、失敗したらアラートを表示 */
    const result = await AccountCreateApi.doAccountCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', 'アカウント登録が完了しました。')
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/account')
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      const payload = result.getPayload()
      if (payload.length === 0 || payload.message === '') {
        this.alertText = '入力内容に不備があります。'
      } else {
        this.alertText = payload.message
      }
      this.showErrorAlert = true
    }
  }

  private isAccountCreate () {
    const accountFlag = Validator.validateInputAccount('accountErrorMessage', this.account)
    const nameFlag = Validator.validateInputName('nameErrorMessage', this.name)
    const telFlag = Validator.validateInputTel('telErrorMessage', this.tel)
    const emailFlag = Validator.validateInputEmail('emailErrorMessage', this.email)
    const passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)

    this.errorMessages = Validator.getErrorMessage()

    return accountFlag && nameFlag && telFlag && emailFlag && passwordFlag
  }

  public showErrorToast (msg: string) {
    this.alertText = msg
    this.showErrorAlert = true
  }

  /* アカウントリストへ戻る */
  private doCancel () {
    this.$router.push('/account')
  }

  private closeAlert () {
    this.showErrorAlert = false
  }
}
